import React from 'react'
import { Outlet } from 'react-router-dom'
// import GridLoadingSpinner from '../components/GridLoadingSpinner/GridLoadingSpinner'
import { useAuthorizationContext } from '../providers/AuthorizationHandler/AuthorizationHandler';
import HeaderAndFooter from '../layouts/HeaderAndFooter/HeaderAndFooter';
import Loader from '../components/Loader';
import { ROUTE_PRIVILEGE } from '../constants/constVariables';
import { useLocation } from "react-router-dom";

export default function PrivateRoutes() {
    const { isAuthenticated, user } = useAuthorizationContext();
    const location = useLocation();
    var check = user?.track_your_vehicle_functions?.some(role => ROUTE_PRIVILEGE[role?.toLowerCase()]?.includes(location?.pathname));
    // console.log("check = ", check)
    return (
        isAuthenticated && user?.isLoaded && check ?
            <HeaderAndFooter><Outlet /></HeaderAndFooter>
            //  <div style={{ height: '100vh', backgroundColor: "#fff", textAlign: 'center', display: "flex", alignItems: "center", justifyContent: "center" }} > <Loader /> </div>
            : <div style={{ height: '100vh', backgroundColor: "#fff", textAlign: 'center', display: "flex", alignItems: "center", justifyContent: "center" }} > <Loader /> </div>
        // auth.token ? <Outlet /> : <div style={{ height: '100%',backgroundColor:"#fff", textAlign: 'center', display: "flex", alignItems: "center", justifyContent: "center" }} > <GridLoadingSpinner /> </div>
    )
}